import Typography from '@/components/ui/Typography'

export function ConnectorSetupSuccessPage(props: any) {
  return (
    <div className="page--connector-setup-success">
      <Typography variant={'xxl'}>You successfully created a connector</Typography>
      <Typography>{props.message || 'You can close this page'}</Typography>
    </div>
  )
}
